import angular from 'angular';
import uiRouter from 'angular-ui-router';
import checksComponent from './checks.component';
import dataTable from 'angular-material-data-table';

let checksModule = angular.module('checks', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('checks', {
        url: '/checks',
        component: 'checks',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('checks', checksComponent)
.name;

export default checksModule;
